// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"a56bdaef","204":"5d58c012","433":"8dd2e3ee","487":"9c6354af","718":"cef95ac7"}[chunkId] + ".chunk.js";
};